let
    ModalDocParameters = {
        Object: null,
        Version: '1.0',
        Title: '',
        Author: '',
        Subject: '',
        Keywords: '',
        Producer: '',
        Compress: true,
        Signed: false,
        BuilderVersion: '',
        FileName: '',
        ItemCountPerDoc: 0,
        MaxThread: 0,
        DataSource: [],
        DataProvider: 'OleDb',
        ConnectionStringTemplate: "Provider=Microsoft.ACE.OLEDB.12.0;Data Source=../~publicfolder~/~datafile~;Extended Properties='Excel 12.0;HDR=YES';",
        ConnectionString: "Provider=Microsoft.ACE.OLEDB.12.0;Data Source=../~publicfolder~/~datafile~;Extended Properties='Excel 12.0;HDR=YES';",
        OleDbPath: '',
        OleDbFile: '',
        OleDbFileBlob: '',
        Encrypted: false,
        EncryptPassword: '',
        EncryptPrint: true,
        EncryptLowQalityPrintX: false,
        EncryptModifyContents: false,
        EncryptExtractContents: false,
        EncryptAnnotation: false,
        EncryptInteractive: false,
        EncryptAccessibility: false,
        EncryptAssembleDoc: false,
        Outline: true,
        OutlineTitle: 'Pages',
        OutlineItem: '',
        OutlineDataSource: '',
        StructuredJsonSample: {
            fileName: '',
            valid: false,
            error: '',
            json: '',
            paths: []
        },
        IsScript: false,
        Script: ''
    }
export default ModalDocParameters;
